<template lang="html">
  <div class="toggle-input" :class="{active: custom}" @click="changeValue">
  	<div class="button"></div>
  </div>
</template>

<script>
export default {
	name: 'toggle-input',
	props: ['value'],
	data () {
		return {
			custom: false
		}
	},
	mounted () {
		this.custom = this.value
	},
	methods: {
		changeValue () {
			this.custom = !this.custom
			this.$emit('change', this.custom)
		}
	}
}
</script>



// WEBPACK FOOTER //
// toggle-input.vue?3c16ed3a